import { Component, Input } from "@angular/core";
import { Figures } from "../services/figure.service";

@Component({
  selector: "app-figure",
  templateUrl: "./figure.component.html",
  styleUrls: ["./figure.component.css"],
})
export class FigureComponent {
  @Input() Color: string;
  @Input() Figure: Figures;
}
